module.exports = __webpack_public_path__ + "img/xiaochijie.61dbd40c.png";